/** InsCoder 2026-09-21 B + Variant-aware member discount visibility and values **/
(function () {
  window.ecoflowMemberDiscount = window.ecoflowMemberDiscount || {};

  var memberDiscount = window.ecoflowMemberDiscount;

  function resolveValue(value, fallback) {
    if (typeof value === 'string' && value.trim() !== '') {
      return value;
    }

    return typeof fallback === 'string' ? fallback : '';
  }

  function getVariantDiscount(config, variantId) {
    var variantConfig = config.variants[String(variantId)] || {};

    return {
      percentage: resolveValue(variantConfig.percentage, config.defaultPercentage),
      code: resolveValue(variantConfig.code, config.defaultCode),
    };
  }

  function updateMessage(root, config, variantId) {
    var discount = getVariantDiscount(config, variantId);
    var hasDiscount = discount.percentage.trim() !== '' && discount.code.trim() !== '';
    var percentageElement = root.querySelector('.member-discount-message__percentage');
    var codeElement = root.querySelector('[data-member-discount-code]');
    var copyButton = root.querySelector('[data-member-discount-copy-btn]');

    root.hidden = !hasDiscount;

    if (!hasDiscount) return;

    if (percentageElement) {
      percentageElement.textContent = discount.percentage;
    }

    if (codeElement) {
      codeElement.textContent = discount.code;
    }

    if (copyButton) {
      copyButton.setAttribute('data-code', discount.code);
    }
  }

  function showCopiedState(button) {
    var textCopy = button.getAttribute('data-text-copy');
    var textCopied = button.getAttribute('data-text-copied');

    button.textContent = textCopied;
    button.classList.add('member-discount-message__btn--copied');

    window.setTimeout(function () {
      button.textContent = textCopy;
      button.classList.remove('member-discount-message__btn--copied');
    }, 2000);
  }

  function fallbackCopy(text, button) {
    var textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var copied = document.execCommand('copy');

      if (copied) {
        showCopiedState(button);
      }
    } catch (error) {
      console.error('Copy failed:', error);
    }

    document.body.removeChild(textArea);
  }

  function copyDiscountCode(button) {
    var code = button.getAttribute('data-code');

    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        showCopiedState(button);
      }).catch(function () {
        fallbackCopy(code, button);
      });
      return;
    }

    fallbackCopy(code, button);
  }

  function initMessage(root) {
    if (root.getAttribute('data-member-discount-initialized') === 'true') return;

    var configElement = root.querySelector('[data-member-discount-config]');
    var productSection = root.closest('[data-section-type="product"]');

    if (!configElement || !productSection) return;

    var config;

    try {
      config = JSON.parse(configElement.textContent);
    } catch (error) {
      console.error('Member discount configuration is invalid:', error);
      return;
    }

    root.setAttribute('data-member-discount-initialized', 'true');

    root.addEventListener('click', function (event) {
      var copyButton = event.target.closest('[data-member-discount-copy-btn]');

      if (copyButton && root.contains(copyButton)) {
        copyDiscountCode(copyButton);
      }
    });

    productSection.addEventListener('variantChange', function (event) {
      if (!event.detail || !event.detail.variant) return;
      updateMessage(root, config, event.detail.variant.id);
    });
  }

  memberDiscount.init = function (scope) {
    var target = scope || document;

    if (target.matches && target.matches('[data-member-discount-message]')) {
      initMessage(target);
    }

    target.querySelectorAll('[data-member-discount-message]').forEach(initMessage);
  };

  if (!memberDiscount.listenersBound) {
    document.addEventListener('DOMContentLoaded', function () {
      memberDiscount.init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      memberDiscount.init(event.target);
    });

    memberDiscount.listenersBound = true;
  }

  memberDiscount.init(document);
})();
/** InsCoder 2026-09-21 E + Variant-aware member discount visibility and values **/
